/*一个类目的筛选条件超过1行 会显示控制伸缩的按钮*/
function filterSwitch(){
  $(function(){
    //控制是否加开关
    $.each($('.options'),function(){
      if ($(this).height()>46) {
        $(this).siblings('.switchs').removeClass('hide');
      }
    });

    //控制收缩
    $('.switchs').on('click', function(event) {
      $(this).children('.hide').siblings().addClass('hide').end().removeClass('hide');
      if ($(this).children('.on').hasClass('hide')) {
        $(this).closest('.filter').removeClass('open').addClass('close');
      }else{
        $(this).closest('.filter').removeClass('close').addClass('open');
      } 
    }); 
  })
}

filterSwitch();

//搜索结果中关键字高亮
+(function () {
  //获取关键字
    var $keyword = $("#keyword").val();
    var reg = new RegExp($keyword);
    var str = "<span class='light-words'>"+$keyword+"</span>";
    //对标题和介绍的文本节点进行遍历并替换
    $(".page-hall .intr").each(function(){
      var jquery_title = $(this).find('.title1 a');
      var jquery_p = $(this).find('.p');
      var title = jquery_title.text().replace(reg, str);
      var p = jquery_p.text().replace(reg, str);
      jquery_title.text('').append(title);  
      jquery_p.text('').append(p);  
    })

})();









// WEBPACK FOOTER //
// ./src/pages/base/hall.js